<template>
  <div
    class="grid-item-drag-handle"
    :class="{
      [`grid-item-drag-handle--${position}`]: true,
      [`grid-item-drag-handle--${size}`]: size,
    }"
  />
</template>

<script>
import { get } from 'lodash-es';

/*
  Override the default size with an entry here for
  a specific module type. This is meant to account for features
  specific to certain modules such as drag-handles and scrollbars.
*/
const DRAG_HANDLE_SIZES = {
  single_selection: { start: 'small', end: 'small' },
  multiple_selection: { start: 'small', end: 'small' },
  prompt: { end: 'small' },
  block: { end: 'small' },
  upload: { end: 'small' },
  asset: { end: 'small' },
};

export default {
  props: {
    position: {
      type: String,
      default: 'top', // top, end, bottom, start
    },
    modType: {
      type: String,
      required: true,
    },
  },
  computed: {
    size() {
      return get(DRAG_HANDLE_SIZES, `${this.modType}.${this.position}`);
    },
  },
};
</script>

<style lang="stylus">
.grid-item-drag-handle {
  position: absolute;
  z-index: 99; // Under resize handle

  $drag-handle-offset = -($nebula-space-half / 2);
  $drag-handle-size = $nebula-space-1x;
  $drag-handle-size-small = $drag-handle-size / 2;

  &--top {
    height: $drag-handle-size;
    left: $drag-handle-offset;
    right: $drag-handle-offset;
    top: $drag-handle-offset;
  }

  &--end {
    bottom: $drag-handle-offset;
    inset-inline-end: $drag-handle-offset;
    top: $drag-handle-offset;
    width: $drag-handle-size;

    &.grid-item-drag-handle--small {
      width: $drag-handle-size-small;
    }
  }

  &--bottom {
    bottom: $drag-handle-offset;
    height: $drag-handle-size;
    left: $drag-handle-offset;
    right: $drag-handle-offset;
  }

  &--start {
    bottom: $drag-handle-offset;
    inset-inline-start: $drag-handle-offset;
    top: $drag-handle-offset;
    width: $drag-handle-size;

    &.grid-item-drag-handle--small {
      width: $drag-handle-size-small;
    }
  }
}
</style>
